import { http } from "../http/Http";
import { AuditLog } from "../models/AuditLog";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";

export class AuditLogService {

    getAuditLogsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<AuditLog[]>> => {
        const { data } = await http.post<ServiceResponse<AuditLog[]>>("AuditLog/GetByFilters", apiQueryFilter);
        return data;
    };

}